import { render } from "./esco-ativar-conta.vue?vue&type=template&id=e19cbb7e&scoped=true"
import script from "./esco-ativar-conta.vue?vue&type=script&lang=js"
export * from "./esco-ativar-conta.vue?vue&type=script&lang=js"

import "./esco-ativar-conta.vue?vue&type=style&index=0&id=e19cbb7e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19cbb7e"]])

export default __exports__